// Imports: local files.
import {
  GET_ALL_ETHNICITIES_START,
  GET_ALL_ETHNICITIES_SUCCESS,
  GET_ALL_ETHNICITIES_FAILED,
  GET_ALL_ETHNICITIES_RESET,
  GET_ONE_ETHNICITY_START,
  GET_ONE_ETHNICITY_SUCCESS,
  GET_ONE_ETHNICITY_FAILED,
  GET_ONE_ETHNICITY_RESET,
  CREATE_ETHNICITY_START,
  CREATE_ETHNICITY_SUCCESS,
  CREATE_ETHNICITY_FAILED,
  CREATE_ETHNICITY_RESET,
  UPDATE_ONE_ETHNICITY_START,
  UPDATE_ONE_ETHNICITY_SUCCESS,
  UPDATE_ONE_ETHNICITY_FAILED,
  UPDATE_ONE_ETHNICITY_RESET,
  DELETE_ONE_ETHNICITY_START,
  DELETE_ONE_ETHNICITY_SUCCESS,
  DELETE_ONE_ETHNICITY_FAILED,
  DELETE_ONE_ETHNICITY_RESET,
} from '../actions/actions';

const initialLoadingState = {
  loading: false,
  success: false,
  data: null,
  error: false,
  errorMessage: null,
};
const initialState = {
  getAll: initialLoadingState,
  getOne: initialLoadingState,
  create: initialLoadingState,
  updateOne: initialLoadingState,
  deleteOne: initialLoadingState,
};

const ethnicitiesReducer = (state = initialState, action) => {
  switch (action.type) {
    /**
     * =======================================================================
     * Get All Ethnicities
     * =======================================================================
     */
    case GET_ALL_ETHNICITIES_START:
      return { ...state, getAll: { ...action.payload } };
    case GET_ALL_ETHNICITIES_SUCCESS:
      return { ...state, getAll: { ...action.payload } };
    case GET_ALL_ETHNICITIES_FAILED:
      return { ...state, getAll: { ...action.payload } };
    case GET_ALL_ETHNICITIES_RESET:
      return { ...state, getAll: { ...initialLoadingState } };
    /**
     * =======================================================================
     * Get One Ethnicity
     * =======================================================================
     */
    case GET_ONE_ETHNICITY_START:
      return { ...state, getOne: { ...action.payload } };
    case GET_ONE_ETHNICITY_SUCCESS:
      return { ...state, getOne: { ...action.payload } };
    case GET_ONE_ETHNICITY_FAILED:
      return { ...state, getOne: { ...action.payload } };
    case GET_ONE_ETHNICITY_RESET:
      return { ...state, getOne: { ...initialLoadingState } };
    /**
     * =======================================================================
     * Create New Ethnicity
     * =======================================================================
     */
    case CREATE_ETHNICITY_START:
      return { ...state, create: { ...action.payload } };
    case CREATE_ETHNICITY_SUCCESS:
      return { ...state, create: { ...action.payload } };
    case CREATE_ETHNICITY_FAILED:
      return { ...state, create: { ...action.payload } };
    case CREATE_ETHNICITY_RESET:
      return { ...state, create: { ...initialLoadingState } };
    /**
     * =======================================================================
     * Update One Ethnicity
     * =======================================================================
     */
    case UPDATE_ONE_ETHNICITY_START:
      return { ...state, updateOne: { ...action.payload } };
    case UPDATE_ONE_ETHNICITY_SUCCESS:
      return { ...state, updateOne: { ...action.payload } };
    case UPDATE_ONE_ETHNICITY_FAILED:
      return { ...state, updateOne: { ...action.payload } };
    case UPDATE_ONE_ETHNICITY_RESET:
      return { ...state, updateOne: { ...initialLoadingState } };
    /**
     * =======================================================================
     * Delete One Ethnicity
     * =======================================================================
     */
    case DELETE_ONE_ETHNICITY_START:
      return { ...state, deleteOne: { ...action.payload } };
    case DELETE_ONE_ETHNICITY_SUCCESS:
      return { ...state, deleteOne: { ...action.payload } };
    case DELETE_ONE_ETHNICITY_FAILED:
      return { ...state, deleteOne: { ...action.payload } };
    case DELETE_ONE_ETHNICITY_RESET:
      return { ...state, deleteOne: { ...initialLoadingState } };
    default:
      return state;
  }
};

export default ethnicitiesReducer;
